import { Component } from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
import Swal from 'sweetalert2';
declare var $:any;

@Component({
  selector: 'app-comman-list',
  templateUrl: './comman-list.component.html',
  styleUrls: ['./comman-list.component.scss']
})
export class CommanListComponent {

  
  public dataListing:any=[];
  public otherdataListing:any=[];

  public AllData:any=[];
  public loading:boolean = true;
  public loginDetail:any =[];
  public totalCount: number = 0;
  public p = 1;
  public ototalCount: number = 0;
  public op = 1;

  public pageLimit:any = 10;
  public previousLabel:any='';
  public nextLabel:any='';
  public searchKey:any='';
  public Ids:any='';  
  public currentUrl:any=this.router.url;

  constructor(public router: Router, public service: GlobalService) { 
    this.loginDetail = JSON.parse(localStorage.getItem('gra_login') || "{}");   
    this.getDetail(this.p);
   }

  ngOnInit(): void {
  }

  getDetail(page:any){  
    this.dataListing=[];  
    this.loading = true;
    var url:any='';
    if(this.currentUrl == '/ability'){
      url='/abilities?page='+page;
    }
    else if(this.currentUrl == '/primary-category'){
      url='/primary-categories?page='+page;
    }
    else if(this.currentUrl == '/content-piller'){
      url='/content-pillars?page='+page;
    }
    else if(this.currentUrl == '/primary-piller'){
      url='/primary-pillar?page='+page;
    }
    else if(this.currentUrl == '/race'){
      url='/races?page='+page;
    }
    else if(this.currentUrl == '/level'){
      url='/levels?page='+page;
    }
    else if(this.currentUrl == '/medical'){
      url='/medical-conditions-listing?page='+page;
      this.getOtherDEtail(1);
    }
    else if(this.currentUrl == '/subcategory'){
      url='/subcategory-list?page='+page;
      this.getOtherDEtail(1);
    }
    else if(this.currentUrl == '/diet'){
      url='/diet-list?page='+page;
      this.getOtherDEtail(1);
    }
    else if(this.currentUrl == '/cookingtime'){
      url='/cooking-times?page='+page;
      this.getOtherDEtail(1);
    }
    else if(this.currentUrl == '/location'){
      url='/area-location-listing?page='+page;
    }
    else if(this.currentUrl == '/suitability'){
      url='/suitability-listing?page='+page;    
    } 
    else if(this.currentUrl == '/demographic'){
      url='/demographic?page='+page;    
    }
    else if(this.currentUrl == '/reasons'){
      url='/reason?page='+page;    
    }

    
    if(this.searchKey!=''){
      url=url+'&search='+this.searchKey; 
    }
      this.service.GetApi(url).subscribe(((response:any)=>{
        if(response.success ==1) {  
          var self=this;
          this.AllData=response.data;
          if(response.data.record.length != 0){
            response.data.record.filter((el:any)=>{
              if(el.childContent !=undefined){
                if(!el.childContent){
                  self.dataListing.push(el);
                }
              } else {
                self.dataListing.push(el);
              }
            })
          }
          // this.dataListing= response.data.record;  
          this.totalCount = response.data.total;  
          this.loading=false;
        } else {
          this.dataListing=[];  
          this.AllData=[];
          this.totalCount = response.data.total;
          this.loading=false;
        }
      }), (error) => { this.loading =false; });
  }

  redirect(item:any,type:any){
    this.Ids =item._id;
    localStorage.setItem('gra_EditData',JSON.stringify(item));
    if(type==1){
      if(this.currentUrl == '/ability'){
        this.router.navigate(['/edit-ability']); 
      }
      else if(this.currentUrl == '/primary-category'){
        this.router.navigate(['/edit-primary-category']); 
      }
      else if(this.currentUrl == '/content-piller'){
        this.router.navigate(['/edit-content-piller']); 
      }
      else if(this.currentUrl == '/primary-piller'){
        this.router.navigate(['/edit-primary-piller']); 
      }
      else if(this.currentUrl == '/race'){
        this.router.navigate(['/edit-race']); 
      }
      else if(this.currentUrl == '/level'){
        this.router.navigate(['/edit-level']); 
      }
      else if(this.currentUrl == '/medical'){
        this.router.navigate(['/edit-medical']); 
      }
      else if(this.currentUrl == '/location'){
        this.router.navigate(['/edit-location']); 
      }
      else if(this.currentUrl == '/suitability'){
        this.router.navigate(['/edit-suitability']); 
      }
      else if(this.currentUrl == '/diet'){
        this.router.navigate(['/edit-diet']); 
      }
      else if(this.currentUrl == '/subcategory'){
        this.router.navigate(['/edit-subcategory']); 
      }
      else if(this.currentUrl == '/cookingtime'){
        this.router.navigate(['/edit-cookingtime']); 
      }
      else if(this.currentUrl == '/demographic'){
        this.router.navigate(['/edit-demographic']); 
      }
      else if(this.currentUrl == '/reasons'){
        this.router.navigate(['/edit-reason']); 
      }
   
    } else {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
      }).then((result:any) => {
        let statusType: number = 0;
        if (result.isConfirmed) {
         this.delete();
        }
      });
    }   
  }
  
  delete(){
    var url1:any='';
    if(this.currentUrl == '/ability'){
      url1='/abilities-delete';
    }
     else if(this.currentUrl == '/diet'){
      url1='/  diet-delete';
    }
    else if(this.currentUrl == '/primary-category'){
      url1='/primary-categories-delete';
    }
    // else if(this.currentUrl == '/content-piller'){
    //   url1='/content-pillars';
    // }
    else if(this.currentUrl == '/race'){
      url1='/race-delete';
    }
    else if(this.currentUrl == '/level'){
      url1='/level-delete';
    }
    else if(this.currentUrl == '/medical'){
      url1='/medical-conditions-delete';
    }
    else if(this.currentUrl == '/location'){
      url1='/area-location-delete';
    }
    else if(this.currentUrl == '/suitability'){
      url1='/suitability-delete';      
    } 
    else if(this.currentUrl == '/reasons'){
      url1='/reason-delete';      
    }
    // else if(this.currentUrl == '/subcategory'){
    //   url1='/subcategory-delete';      
    // }
      this.service.PostApis({'id':this.Ids},url1).subscribe(((response:any)=>{
        if(response.success ==1) {  
          this.loading=false;
          this.p=1;
          this.getDetail(this.p);
        } else {
          this.loading=false;
        }
      }), (error) => { this.loading =false; });

  } 

  getOtherDEtail(page:any){
    this.loading=true;
    var url='';
    if(this.currentUrl == '/medical'){
      url='/other-medical-condition?page='+page;
    }
    else if(this.currentUrl == '/subcategory'){
      url='/other-subcategory-list?page='+page;
    }
    else if(this.currentUrl == '/diet'){
      url='/other-diet-list?page='+page;
    }
    else if(this.currentUrl == '/cookingtime'){
      url='/other-cooking-list?page='+page;
    }
    this.service.GetApi(url).subscribe(((response:any)=>{
      if(response.success ==1) {  
        this.otherdataListing= response.data.record;  
        this.ototalCount = response.data.total;  
        this.loading=false;
      } else {
        this.otherdataListing=[];  
        this.ototalCount = response.data.total;
        this.loading=false;
      }
    }), (error) => { this.loading =false; });
  }

  otherApprove(id:any){
    this.loading=true;
    var url='';
    if(this.currentUrl == '/medical'){
      url='/medical-approval-request';
    }
    else if(this.currentUrl == '/subcategory'){
      url='/subcategory-approval-request';
    }
    else if(this.currentUrl == '/diet'){
      url='/diet-approval-request';
    }
    else if(this.currentUrl == '/cookingtime'){
      url='/cooking-approval-request';
    }
    var detail={
      "id":id
     }
    this.service.PostApis(detail,url).subscribe(((response:any)=>{
      if(response.success==1){
        this.getDetail(this.p);
        this.service.successAlert(response.message);
        this.loading= false;       
      } else {
        this.service.dangerAlert(response.message);
        this.loading= false;
      }
    })) 
  }

  updateStatus(data:any){
    var status:any='';
    if(data.status=='Active'){
      status='In-active';
    } else {
      status='Active';
    }
    Swal.fire({
      title: 'Are you sure?',
      text: "You want to change the status?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, change it!',
    }).then((result:any) => {
      if (result.isConfirmed) {    
          this.update(data._id,status);       
      } else {
        this.getDetail(this.p);
      }
    });

  }

  update(data:any,status:any){
    var url:any='';
    if(this.currentUrl == '/ability'){
      url='/abilities-changeStatus';
    }
    else if(this.currentUrl == '/primary-category'){
      url='/primary-categories-changeStatus';
    }
    else if(this.currentUrl == '/content-piller'){
      url='/content-pillars-changeStatus';
    }
    else if(this.currentUrl == '/race'){
      url='/race-changeStatus';
    }
    else if(this.currentUrl == '/level'){
      url='/level-changeStatus';
    }
    else if(this.currentUrl == '/medical'){
      url='/medical-conditions-changeStatus';
    }
    else if(this.currentUrl == '/subcategory'){
      url='/subcategory-changeStatus';
    }
    else if(this.currentUrl == '/diet'){
      url='/diet-changeStatus';
    }
    else if(this.currentUrl == '/cookingtime'){
      url='/cooking-times-changeStatus';
    }
    else if(this.currentUrl == '/location'){
      url='/area-location-changeStatus';
    }
    else if(this.currentUrl == '/suitability'){
      url='/suitability-changeStatus';    
    }
    else if(this.currentUrl == '/reasons'){
      url='/reason-status-update';    
    }
    var detail={
      "status": status,
      "id": data
  }
    this.service.PostApis(detail,url).subscribe(((response:any)=>{
      if(response.success ==1){         
        this.loading=false; 
        this.p=1; 
        this.getDetail(this.p);
      } else {
        this.service.dangerAlert(response.message);
        this.loading=false;
      }
    }), (error:any) => {
      this.loading=false;
    });
  }

}
